'use es6';

export default (properties => {
  return properties.map(property => property.set('value', property.get('name')).remove('name'));
});